// Join class names, skipping falsy parts (conditional Tailwind classes).
export const cx = (...parts) => parts.filter(Boolean).join(' ');

export default cx;
